import React, { Suspense } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { Container } from "components/shared";
import {
  PAGE_CONTAINER_GUTTER_X,
  PAGE_CONTAINER_GUTTER_Y,
} from "constants/theme.constant";
import Footer from "components/template/Footer";
import useCustomerMobileShell from "utils/hooks/useCustomerMobileShell";

const CustomHeader = ({ header }) => {
  const Header = header;
  return <Header />;
};

const PageContainer = (props) => {
  const {
    pageContainerType,
    children,
    header,
    contained,
    extraHeader,
    footer,
  } = props;

  const customerMobileShell = useCustomerMobileShell();
  const location = useLocation();
  const effectiveFooter = customerMobileShell ? false : footer;
  const pageBody = customerMobileShell ? (
    <div key={location.pathname} className="customer-mobile-page-enter">
      {children}
    </div>
  ) : (
    children
  );

  return (
    <div
      className={classNames(
        "flex flex-auto flex-col",
        customerMobileShell
          ? "w-full min-h-0 shrink-0"
          : "h-full justify-between"
      )}
    >
      <main
        className={classNames(
          customerMobileShell ? "w-full min-h-0 flex flex-col" : "h-full"
        )}
      >
        <div
          className={classNames(
            "page-container relative flex flex-auto flex-col px-4 sm:px-6 md:px-8 py-4 sm:py-6",
            !customerMobileShell && "h-full",
            pageContainerType !== "gutterless" &&
              `${PAGE_CONTAINER_GUTTER_X} ${PAGE_CONTAINER_GUTTER_Y}`,
            pageContainerType === "contained" && "container mx-auto",
            customerMobileShell && "pt-3"
          )}
        >
          {(header || extraHeader) && (
            <div
              className={classNames(
                contained && "container mx-auto",
                "flex items-center justify-between mb-4"
              )}
            >
              <div>
                {header && typeof header === "string" && <h3>{header}</h3>}
                <Suspense fallback={<div></div>}>
                  {header && typeof header !== "string" && (
                    <CustomHeader header={header} />
                  )}
                </Suspense>
              </div>
              <Suspense fallback={<div></div>}>
                {extraHeader && typeof extraHeader !== "string" && (
                  <CustomHeader header={extraHeader} />
                )}
              </Suspense>
            </div>
          )}
          {pageContainerType === "contained" ? (
            <Container
              className={customerMobileShell ? undefined : "h-full"}
            >
              {pageBody}
            </Container>
          ) : (
            pageBody
          )}
        </div>
      </main>
      {effectiveFooter && <Footer pageContainerType={pageContainerType} />}
    </div>
  );
};

PageContainer.defaultProps = {
  pageContainerType: "default",
  contained: false,
  footer: true,
};

PageContainer.propTypes = {
  pageContainerType: PropTypes.oneOf(["default", "gutterless", "contained"]),
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  extraHeader: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  contained: PropTypes.bool,
  footer: PropTypes.bool,
};

export default PageContainer;
